import React from "react";
import { FaCheck, FaTimes } from "react-icons/fa";

const PricingSection = () => {
  const iconColor = "#1d678e"; // Couleur bleue pour les icônes

  return (
    <section className="section-padding bg-blck">
      <div className="container">
        <div className="row">
          {/* Première carte */}
          <div className="col-md-4 d-flex align-items-stretch">
            <div
              className="pricing2 w-100"
              style={{
                height: "530px",
                backgroundColor: "#202020",
                position: "relative",
              }}
            >
              <div className="con text-center">
                <span className="price">
                  <sup> à partir de</sup> <span className="number">350</span>{" "}
                  <sub>EUR</sub>
                </span>
                <span className="title d-block mb-5">Pack Photo - Base</span>
                <ul
                  className="pricing-text mb-30"
                  style={{ paddingLeft: "0", gap: "5px" }}
                >
                  <li
                    style={{
                      listStyleType: "none",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      lineHeight: "1.5", // Line height for better alignment
                    }}
                  >
                    <FaCheck style={{ color: iconColor, width: "20px" }} />2
                    heures de séance photo
                  </li>
                  <li
                    style={{
                      listStyleType: "none",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      lineHeight: "1.5",
                    }}
                  >
                    <FaCheck style={{ color: iconColor, width: "20px" }} />
                    Retouches incluses
                  </li>
                  <li
                    style={{
                      listStyleType: "none",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      lineHeight: "1.5",
                    }}
                  >
                    <FaCheck style={{ color: iconColor, width: "20px" }} />2
                    révisions possibles
                  </li>
                </ul>
              </div>
              <a
                href="/contact"
                className="button-tersiyer"
                style={{
                  position: "absolute",
                  bottom: "20px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  width: "50%",
                  textAlign: "center",
                }}
              >
                En Savoir Plus
              </a>
            </div>
          </div>

          {/* Deuxième carte */}
          <div
            className="col-md-4 d-flex align-items-stretch"
            style={{ marginTop: "2%" }}
          >
            <div
              className="pricing2 w-100"
              style={{
                height: "530px",
                backgroundColor: "#202020",
                position: "relative",
                border: "1px solid #1d678e",
                borderRadius: "8px",
              }}
            >
              <div className="con text-center">
                <span className="price">
                  <sup> à partir de</sup> <span className="number">750</span>{" "}
                  <sub>EUR</sub>
                </span>
                <span className="title d-block">
                  Pack Premium - Photo & Vidéo
                </span>
                <ul
                  className="pricing-text mb-30"
                  style={{ paddingLeft: "0", gap: "5px" }}
                >
                  <li
                    style={{
                      listStyleType: "none",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      lineHeight: "1.5",
                    }}
                  >
                    <FaCheck style={{ color: iconColor, width: "20px" }} />
                    Services Packs Photo et Vidéo
                  </li>
                  <li
                    style={{
                      listStyleType: "none",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      lineHeight: "1.5",
                    }}
                  >
                    <FaCheck style={{ color: iconColor, width: "20px" }} />2
                    heures de séance photo
                  </li>
                  <li
                    style={{
                      listStyleType: "none",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      lineHeight: "1.5",
                    }}
                  >
                    <FaCheck style={{ color: iconColor, width: "20px" }} />2
                    heures de tournage vidéo
                  </li>
                  <li
                    style={{
                      listStyleType: "none",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      lineHeight: "1.5",
                    }}
                  >
                    <FaCheck style={{ color: iconColor, width: "20px" }} />
                    Retouches photo (2 révisions)
                  </li>
                  <li
                    style={{
                      listStyleType: "none",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      lineHeight: "1.5",
                    }}
                  >
                    <FaCheck style={{ color: iconColor, width: "20px" }} />
                    Montage vidéo (3 révisions)
                  </li>
                </ul>
              </div>
              <a
                href="/contact"
                className="button-tersiyer"
                style={{
                  position: "absolute",
                  bottom: "20px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  width: "50%",
                  textAlign: "center",
                }}
              >
                En Savoir Plus
              </a>
            </div>
          </div>

          {/* Troisième carte */}
          <div className="col-md-4 d-flex align-items-stretch">
            <div className="pricing2 w-100 d-flex flex-column">
              <div className="con text-center flex-grow-1">
                <span className="price">
                  <sup> à partir de</sup> <span className="number">450</span>
                  <sub>EUR</sub>
                </span>
                <span className="title d-block mb-5">Pack Vidéo - Base</span>
                <ul
                  className="pricing-text mb-30"
                  style={{ paddingLeft: "0", gap: "5px" }}
                >
                  <li
                    style={{
                      listStyleType: "none",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      lineHeight: "1.5",
                    }}
                  >
                    <FaCheck style={{ color: iconColor, width: "20px" }} />2
                    heures de tournage vidéo
                  </li>
                  <li
                    style={{
                      listStyleType: "none",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      lineHeight: "1.5",
                    }}
                  >
                    <FaCheck style={{ color: iconColor, width: "20px" }} />
                    Montage vidéo inclus
                  </li>
                  <li
                    style={{
                      listStyleType: "none",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      lineHeight: "1.5",
                    }}
                  >
                    <FaCheck style={{ color: iconColor, width: "20px" }} />3
                    révisions possibles
                  </li>
                </ul>
              </div>
              <a
                href="/contact"
                className="button-tersiyer mb-4"
                style={{
                  width: "50%",
                  margin: "0 auto",
                  textAlign: "center",
                }}
              >
                En Savoir Plus
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
